import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';

export interface TermsandConditionCSSStyle extends CRBTUICSSStyle
{
    getTextCSSStyle(): object;
    getTitleTextCSSStyle(): object;
   

    getMobileTextCSSStyle(): object;
    getMobileTitleTextCSSStyle(): object;
   
}

export class TermsandConditionCSSStyleImpl extends CRBTUICSSStyleImpl implements TermsandConditionCSSStyle
{
    getWrapperCSSStyle()
    {
        return{
            width: "100%",
            marginTop: "20px",
        };
    }
    

    getTextCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h16),
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 900,
            letterSpacing: 0,
            lineHeight: "80px",
            width: "100%",
            textAlign: "center",
        };
    }
    getTitleTextCSSStyle(): object {
        return {

            textAlign: "center",
            fontSize: this.getResources().getFont(Fonts.h12),
            color: this.getResources().getColor(Colors.color_15),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 500,
            letterSpacing: 0,
            lineHeight: "40px",
            boxSizing: "border-box",
            // height: "60px",
            width: "100%",
            marginTop: "20px",
          };
    }

   

    
     

    getMobileTextCSSStyle(): object {
        return {
            fontSize: "25px",
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 900,
            letterSpacing: 0,
            lineHeight: "40px",
            width: "100%",
            textAlign: "center",
        };
    }
    getMobileTitleTextCSSStyle(): object {
        return {

            textAlign: "center",
            fontSize: "14.5px",
            color: this.getResources().getColor(Colors.color_15),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 500,
            letterSpacing: 0,
            lineHeight: "20px",
            boxSizing: "border-box",
            // height: "60px",
            width: "100%",
            marginTop: "10px",
          };
    }

    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/termsandcondition/termsandconditioncss.tsx